<template>
  <div ref="box" class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" />
    <header
      style="width: 100%; height: 72px; background-color: rgba(8, 6, 27, 0.8)"
    ></header>
    <p class="p">{{ item.title }}</p>
    <div class="time">{{ item.createDate }}</div>
    <div class="content" v-html="bigdata"></div>
    <div class="prevBox">
      <div v-if="prevId!==0" class="leftbox" @click="getPrevDetails">
        <span>上一篇</span>
        <div class="line"></div>
        <p>{{PrevData.title}}</p>
        <div class="undertext">
          <b>{{Datatype==0?'企业事纪':'行业资讯'}}</b><i>|&nbsp;&nbsp;&nbsp;{{PrevData.createDate}}</i>
        </div>
      </div>
      <div v-if="nextId!==0" class="leftbox" @click="getNextDetails">
        <span>下一篇</span>
        <div class="line"></div>
        <p>{{NextData.title}}</p>
        <div class="undertext">
          <b>{{Datatype==0?'企业事纪':'行业资讯'}}</b><i>|&nbsp;&nbsp;&nbsp;{{NextData.createDate}}</i>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import { getDetils, getZoxunList } from '@/api/index.js'
// let DEtails = this.$route.query.id
export default {
  name: 'Informationdetails',
  data () {
    return {
      bigdata: '',
      item: {},
      ziXunList: [], //资讯列表
      prevId: '',
      nextId: '',
      PrevData: '', //上一篇文章的信息
      NextData: '', //下一篇文章的信息
      Datatype: 0,
    }
  },
  mounted () {

    this.getDetilsdata()
    

  },
  methods: {
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
    //上一篇信息-预处理
   async getPrevData() {
      const res  = await getDetils(this.prevId)
      this.PrevData = res.data.articleCopy
    },
    //下一篇信息预处理
    async getNextData() {
      const res = await getDetils(this.nextId)
      this.NextData = res.data.articleCopy
    },
    // 获取上一篇内容信息
    async getPrevDetails () {

      const res = await getDetils(this.prevId)
      this.bigdata = res.data.articleCopy.content
      this.item = res.data.articleCopy
      // this.Details = res.data.articleCopy.id
      this.$refs.box.scrollTo(0, 0)
      this.prevId = res.data.lastPage
      this.nextId = res.data.nextPage
      this.getPrevData()
        this.getNextData()

    },
    //获取下一篇的内容信息
    async getNextDetails () {
      const res = await getDetils(this.nextId)
      this.bigdata = res.data.articleCopy.content
      this.item = res.data.articleCopy
      // this.Details = res.data.articleCopy.id
      this.prevId = res.data.lastPage
      this.nextId = res.data.nextPage
      this.$refs.box.scrollTo(0, 0)
      this.getPrevData()
        this.getNextData()
    },

    async getDetilsdata () {
      this.Datatype = this.$route.query.type
     

      const res = await getDetils(this.$route.query.id)
      // this.Datatype = this.$route.query.type
      this.bigdata = res.data.articleCopy.content
      this.item = res.data.articleCopy
      this.prevId = res.data.lastPage
      this.nextId = res.data.nextPage
      this.$nextTick(()=>{
        this.getPrevData()
        this.getNextData()
      })
    }

  }

}
</script>

<style lang="scss" scoped>
.prevBox {
  margin: 0 auto;
  // margin-top: 50px;
  margin-bottom: 160px;
  height: 160px;
  width: 67%;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  .leftbox {
    float: left;
    width: 420px;
    height: 250px;
    background: linear-gradient(90deg, #3657bb, #25439e);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: start;
    padding-left: 30px;
    text-align: left;
    // cursor:hand
    span {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .line {
      width: 30px;
      height: 2px;
      background: #ffffff;
      margin-bottom: 40px;
    }
    p {
      margin-bottom: 30px;
      font-size: 16px;
      width: 100%;
      padding-right: 30px;
      font-family: PingFang SC;
      font-weight: 400;
        color: #ffffff;
      
    }
    b {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-right: 20px;
    }
    i {
      font-style: normal;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
    }
  }
  .leftbox:hover{
    p {
      color: #f4930f;
    }
  }
  .rightbox {
    float: left;
    width: 420px;
    height: 250px;
    background: linear-gradient(90deg, #3657bb, #25439e);
    display: flex;
    justify-content: center;
    flex-direction: column;
    // align-items: right;
    align-items: flex-end;
    padding-right: 30px;
    text-align: right;
    // cursor:pointer
    span {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 20px;
    }
    .line {
      float: right;

      width: 30px;
      height: 2px;
      background: #ffffff;
      margin-bottom: 40px;
    }
    p {
      margin-bottom: 30px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      width: 100%;
      padding-left: 30px;
    }
    b {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-right: 20px;
    }
    i {
      font-style: normal;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
    }
  }
  .rightbox:hover {
    p {
      color: #f4930f;
    }
  }
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.content {
  /* padding-top: 90px; */
  width: 65%;
  margin: 0 auto;
  // background: #f8f8f8;
  overflow: hidden;
}
.p {
  margin: 0 auto;
  width: 65%;
  text-align: center;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #333333;
  margin-top: 80px;
}
.time {
  text-align: center;
  margin: 0 auto;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-bottom: 50px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Information-details.vue